"use client";
import classNames from "classnames";
import Link from "next/link";
import pluralize from "utils/pluralize";
import styles from "./home.module.css";
// import DOMPurify, { sanitize } from "dompurify";
import DOMPurify from "isomorphic-dompurify";
import ProductCard from "component/productCard";

function CategorySection({ category }: { category: Category }) {
  return (
    <section className={classNames("container", styles.categorySection)}>
      <h2>{category.name ? DOMPurify.sanitize(category.name) : ""}</h2>
      <p className="text-center text-sm">
        {category.desc ? DOMPurify.sanitize(category.desc) : ""}
      </p>
      <ul className={styles.products}>
        {category.products.map((product) => (
          // <li key={product.id} className={styles.cardgrey}>
          //   <Link prefetch={false} href={`/product/${DOMPurify.sanitize(product.id)}`}>
          //     <div className={styles.productImage}>
          //       <img src={DOMPurify.sanitize(product.primary_img_url)} loading="lazy" alt={product.name} />
          //     </div>
          //     <h3>{product.name}</h3>
          //     <h2>₦{DOMPurify.sanitize((product.price + (product.installation_fee || 0)).toLocaleString())}</h2>
          //   </Link>
          // </li>
          <ProductCard
            key={product.id}
            product={{
              ...product,
              images: [DOMPurify.sanitize(product.primary_img_url)],
            }}
          />
        ))}
      </ul>
      <a
        href={`/shop?${new URLSearchParams({
          category: category.name,
        })}`}
        className="btn btn-lg btn-green"
      >
        View all {DOMPurify.sanitize(pluralize(category.name))}
      </a>
      <hr />
    </section>
  );
}

function getRandomFour<T extends any>(array: T[]): T[] {
  if (array.length < 4) return array.sort(() => (Math.random() < 0.5 ? 1 : -1));
  const randomlyPicked = [];
  const picked = new Set<number>();

  while (randomlyPicked.length < 4) {
    const randomIndex = Math.floor(Math.random() * array.length);

    if (picked.has(randomIndex)) continue;

    picked.add(randomIndex);

    randomlyPicked.push(array[randomIndex]);
  }

  return randomlyPicked;
}

export default CategorySection;
